import { useGoogleCalendarUpcoming } from "@/hooks/useGoogleCalendarUpcoming";

type Props = {
  open: boolean;
};

/** WC-GCAL — inbound Google events in the activity bell (Layer A). */
export function ActivityBannerGoogleCalendarSection({ open }: Props) {
  const { events, linked, loading, error } = useGoogleCalendarUpcoming(open);

  if (!open || !linked) return null;

  return (
    <div className="border-t border-gray-100 dark:border-gray-800 px-4 py-3">
      <p className="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Upcoming on your calendar</p>
      {loading && events.length === 0 ? (
        <p className="text-[11px] text-gray-500 mt-1">Loading Google Calendar…</p>
      ) : null}
      {error ? <p className="text-[11px] text-red-600 dark:text-red-300 mt-1">{error}</p> : null}
      {!loading && events.length === 0 ? (
        <p className="text-[11px] text-gray-500 mt-1">No external Google events in the sync window.</p>
      ) : (
        <ul className="mt-2 space-y-2">
          {events.slice(0, 6).map((ev) => (
            <li key={ev.notification_id} className="text-[11px] rounded-lg border border-gray-200/80 dark:border-gray-700 px-2 py-1.5">
              <p className="font-medium text-gray-900 dark:text-gray-100">{ev.title}</p>
              <p className="text-gray-500 dark:text-gray-400">{ev.start_label}</p>
              {ev.html_link ? (
                <a
                  href={ev.html_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[10px] font-medium text-indigo-700 dark:text-indigo-300 underline"
                >
                  Open in Google Calendar
                </a>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
